import {
  Button,
  Container,
  Fab,
  makeStyles,
  Modal,
  Snackbar,
  Tooltip,
} from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import React, { useState } from "react";
import $ from "jquery";
import MuiAlert from "@material-ui/lab/Alert";
import ChargeService from "../../../services/ChargesPayement/ChargeService";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 500,
    height: 200,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
    },
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },

  cancelAndAddButtom: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));

const UploadChargeFileDownloaded = ({
  setOnUploadFile,
  chargeUrlFileDownloads,
}) => {
  const classes = useStyles();

  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState([]);


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const uploadFile = () => {
    if (file.length !== 0) {
      const uploadData = new FormData();
      uploadData.append("picture", file);
      uploadAndDownloadService
        .uploadFile("/retail/uploadFile/uploadFile/Charge", uploadData)
        .then((response) => {
          if (response.data["success"]) {
            let uploadModel = {
              idUser: getCurrentUserId(),
              urlFileUploaded: response.data.success,
              idCharge:chargeUrlFileDownloads.idCharge,
            };
            ChargeService.uploadFileDownloaded(uploadModel)
              .then((response) => {
                console.log(response);
                if (response.data["error"]) {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur :  " + response.data["error"]);
                } else {
                  setTimeout(() => {
                    window.location.reload(true);
                  }, 2000);
                }
              })
              .catch((error) => {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur :  " + error);
              });
            }
        }).catch((error) => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :  " + error);
          });
    } else {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : pas de fichier");
    }
  };

  const onUploadFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setFileName(e.target.files[0].name);

      setFile(e.target.files[0]);
    }
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnUploadFile(false);
  };


  return (
    <>
      <Tooltip title="Add" aria-label="add" onClick={() => setOpen(true)}>
        <Fab color="primary" className={classes.fab}>
          <AddIcon />
        </Fab>
      </Tooltip>
      <Modal open={open}>
        <Container className={classes.container}>
          <form className={classes.form} autoComplete="off">
            <div className="row">
              <div class="col-md-12">
                <div className="row">
                  <div className="col-sm-12">
                    <div class="form-group">
                      <label for="exampleInputFile">
                        Ajouter le fichier à déposer à l'état{" "}
                      </label>
                      <div class="input-group">
                        <div class="custom-file">
                          <input
                            accept="application/pdf, .jpg, .jpeg, .png"
                            type="file"
                            className="custom-file-input"
                            id="exampleInputFile"
                            onChange={onUploadFileHandler}
                          />
                          <label
                            class="custom-file-label"
                            for="exampleInputFile"
                          >
                            {fileName}{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             
            </div>

            <div className={classes.cancelAndAddButtom}>
              <Button
                variant="outlined"
                color="primary"
                style={{ marginRight: 20 }}
                onClick={() => uploadFile()}
                >
                Ajouter
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={onCancelButtonHandler}
              >
                Quitter
              </Button>
            </div>
          </form>
        </Container>
      </Modal>
      <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};
export default UploadChargeFileDownloaded;
